import * as React from "react";
import "./Spinner.scss";
import { Box, Typography, CircularProgress } from "@mui/material";
import cn from "classnames";

export default function Spinner({ className = "cgv-spinner-container", uploadProgress, isProgress, opacity = "0.62" }) {
  if (isProgress)
    return (
      <div
        className={className}
        // className={cn({ "cgv-spinner-container": !isPart }, className)}
        style={{ background: `rgba(106, 106, 106, ${opacity})` }}>
        <Box sx={{ position: "relative", display: "inline-flex" }}>
          <CircularProgress variant="determinate" value={uploadProgress} size={60} thickness={4} />
          <Box
            sx={{
              top: 0,
              left: 0,
              bottom: 0,
              right: 0,
              position: "absolute",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}>
            <Typography variant="caption" component="div" color="text.secondary" fontWeight="bold" fontSize="14px">
              {`${uploadProgress}%`}
            </Typography>
          </Box>
        </Box>
      </div>
    );
  return (
    <div className={className}>
      <div className="cgv-spinner-mini-loader" />
    </div>
  );
}
